// in dev, this makes Vite inject its client as this module's first dependency,
// so that global constant replacements are installed before any other module
// (including user hooks) evaluates. In build it's inert.
import.meta.hot;

import * as client_hooks from '../../../src/hooks.client.ts';


export { matchers } from './matchers.js';

export const nodes = [
	() => import('./nodes/0'),
	() => import('./nodes/1'),
	() => import('./nodes/2'),
	() => import('./nodes/3'),
	() => import('./nodes/4'),
	() => import('./nodes/5'),
	() => import('./nodes/6'),
	() => import('./nodes/7'),
	() => import('./nodes/8'),
	() => import('./nodes/9'),
	() => import('./nodes/10'),
	() => import('./nodes/11'),
	() => import('./nodes/12'),
	() => import('./nodes/13'),
	() => import('./nodes/14'),
	() => import('./nodes/15'),
	() => import('./nodes/16'),
	() => import('./nodes/17'),
	() => import('./nodes/18'),
	() => import('./nodes/19'),
	() => import('./nodes/20'),
	() => import('./nodes/21'),
	() => import('./nodes/22'),
	() => import('./nodes/23'),
	() => import('./nodes/24'),
	() => import('./nodes/25'),
	() => import('./nodes/26'),
	() => import('./nodes/27'),
	() => import('./nodes/28'),
	() => import('./nodes/29'),
	() => import('./nodes/30'),
	() => import('./nodes/31'),
	() => import('./nodes/32'),
	() => import('./nodes/33'),
	() => import('./nodes/34'),
	() => import('./nodes/35'),
	() => import('./nodes/36'),
	() => import('./nodes/37'),
	() => import('./nodes/38'),
	() => import('./nodes/39'),
	() => import('./nodes/40'),
	() => import('./nodes/41'),
	() => import('./nodes/42'),
	() => import('./nodes/43'),
	() => import('./nodes/44'),
	() => import('./nodes/45'),
	() => import('./nodes/46'),
	() => import('./nodes/47'),
	() => import('./nodes/48'),
	() => import('./nodes/49'),
	() => import('./nodes/50'),
	() => import('./nodes/51'),
	() => import('./nodes/52'),
	() => import('./nodes/53'),
	() => import('./nodes/54'),
	() => import('./nodes/55'),
	() => import('./nodes/56'),
	() => import('./nodes/57'),
	() => import('./nodes/58'),
	() => import('./nodes/59'),
	() => import('./nodes/60'),
	() => import('./nodes/61'),
	() => import('./nodes/62'),
	() => import('./nodes/63'),
	() => import('./nodes/64'),
	() => import('./nodes/65'),
	() => import('./nodes/66'),
	() => import('./nodes/67'),
	() => import('./nodes/68'),
	() => import('./nodes/69'),
	() => import('./nodes/70'),
	() => import('./nodes/71'),
	() => import('./nodes/72'),
	() => import('./nodes/73'),
	() => import('./nodes/74'),
	() => import('./nodes/75'),
	() => import('./nodes/76'),
	() => import('./nodes/77'),
	() => import('./nodes/78'),
	() => import('./nodes/79'),
	() => import('./nodes/80'),
	() => import('./nodes/81')
];

export const server_loads = [0,5,6,4,3];

export const dictionary = {
		"/(app)": [11,[2]],
		"/(app)/+[usernameOrId=username_or_id]": [~20,[2]],
		"/(app)/+[usernameOrId=username_or_id]/og.png/preview": [~21,[2]],
		"/(app)/@[org=org_code]": [~22,[2,5]],
		"/(app)/@[org=org_code]/(members)/billing": [~23,[2,5,6]],
		"/(app)/@[org=org_code]/(members)/contests": [24,[2,5,6]],
		"/(app)/@[org=org_code]/join": [33,[2,5]],
		"/(app)/@[org=org_code]/join/check-email": [34,[2,5]],
		"/(app)/@[org=org_code]/join/with-email": [~35,[2,5]],
		"/(app)/@[org=org_code]/(members)/leave": [25,[2,5,6]],
		"/(app)/@[org=org_code]/(members)/members": [~26,[2,5,6]],
		"/(app)/@[org=org_code]/(members)/notifications": [27,[2,5,6]],
		"/(app)/@[org=org_code]/(members)/sessions": [28,[2,5,6]],
		"/(app)/@[org=org_code]/(members)/settings": [29,[2,5,6]],
		"/(app)/@[org=org_code]/(members)/teams": [30,[2,5,6]],
		"/(app)/@[org=org_code]/(members)/teams/[teamId=integer]": [~31,[2,5,6]],
		"/(app)/@[org=org_code]/[code=session_code]": [~32,[2,5]],
		"/_email/manage-topics": [~79,[10]],
		"/_email/unsubscribe": [~80,[10]],
		"/(app)/admin": [36,[2]],
		"/(app)/admin/booth": [37,[2]],
		"/(app)/admin/colors": [38,[2]],
		"/(app)/admin/components": [39,[2]],
		"/(app)/admin/movements": [40,[2]],
		"/(app)/admin/new-movement": [41,[2]],
		"/(app)/admin/newsletters": [~42,[2]],
		"/(app)/admin/reveal": [43,[2]],
		"/(app)/admin/robot": [44,[2]],
		"/(app)/admin/stats": [~45,[2]],
		"/(app)/admin/stripe": [~46,[2]],
		"/(app)/business": [47,[2]],
		"/(app)/contact": [48,[2]],
		"/(app)/contests/[contestId=integer]": [49,[2]],
		"/dev/voice-chat-loopback": [~81],
		"/(app)/help": [50,[2,7]],
		"/(app)/help/[...slugs]": [51,[2,7]],
		"/(app)/internal/movement": [52,[2]],
		"/(app)/legal/legal-notice": [53,[2,8]],
		"/(app)/legal/privacy-policy": [54,[2,8]],
		"/(app)/legal/terms-of-service": [55,[2,8]],
		"/(app)/(auth)/(signed-out)/login": [13,[2,4]],
		"/(app)/(auth)/logout": [16,[2]],
		"/(app)/pomodoro": [~56,[2]],
		"/(app)/pricing": [~57,[2]],
		"/(app)/(auth)/(signed-out)/register": [14,[2,4]],
		"/(app)/(auth)/register/finish": [17,[2]],
		"/(app)/(auth)/(signed-out)/reset-password": [15,[2,4]],
		"/(app)/(auth)/reset-password/set": [18,[2]],
		"/(app)/session/create": [60,[2]],
		"/(app)/session/embeddable": [61],
		"/(app)/session/[sessionUid=session_uid]": [~58,[2]],
		"/(app)/session/[sessionUid=session_uid]/join": [59,[2]],
		"/(app)/settings": [62,[2,9]],
		"/(app)/settings/account": [63,[2,9]],
		"/(app)/settings/billing": [~64,[2,9]],
		"/(app)/settings/contests": [65,[2,9]],
		"/(app)/settings/contests/new": [68,[2,9]],
		"/(app)/settings/contests/[contestId=integer]": [66,[2,9]],
		"/(app)/settings/contests/[contestId=integer]/edit": [67,[2,9]],
		"/(app)/settings/friends": [69,[2,9]],
		"/(app)/settings/friends/requests": [~70,[2,9]],
		"/(app)/settings/notifications": [71,[2,9]],
		"/(app)/settings/notifications/link-slack": [72,[2,9]],
		"/(app)/settings/organizations": [73,[2,9]],
		"/(app)/settings/organizations/add-slack-workspace": [74,[2,9]],
		"/(app)/settings/organizations/add-slack-workspace/success": [75,[2,9]],
		"/(app)/settings/organizations/link-slack": [~76,[2,9]],
		"/(app)/settings/organizations/new": [77,[2,9]],
		"/(app)/settings/profile": [78,[2,9]],
		"/(app)/(auth)/verify-email": [19,[2]],
		"/(app)/(auth)/(signed-in)/welcome": [12,[2,3]]
	};

export const hooks = {
	handleError: client_hooks.handleError || (({ error }) => { console.error(error) }),
	init: client_hooks.init,
	reroute: (() => {}),
	transport: {}
};

export const decoders = Object.fromEntries(Object.entries(hooks.transport).map(([k, v]) => [k, v.decode]));
export const encoders = Object.fromEntries(Object.entries(hooks.transport).map(([k, v]) => [k, v.encode]));

export const hash = false;

export const decode = (type, value) => decoders[type](value);

export { default as root } from '../root.js';

export const get_error_template = () => import('../shared/error-template.js').then(m => m.default);